module.exports = __webpack_public_path__ + "static/media/mm7.8d9ba545.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/med i mleko/mm7.jpg
// module id = 428
// module chunks = 0